module.exports = __webpack_public_path__ + "static/media/main-es.cb0274c0.webp";